export const PRIMARY = "PRIMARY_DESIGN";
export const SECONDARY = "SECONDARY_DESIGN";
export const DANGER = "DANGER_DESIGN";
export const ACCENT = "ACCENT_DESIGN";
